// extracted by mini-css-extract-plugin
export default {"globalColors":"colors_globalColors__e1Fi0","dark":"colors_dark__7+JWn","globalColorsDark":"colors_globalColorsDark__xZojr"};